export const twPaginationComponent = {
  key: 'twPaginationComponent',
  name: 'Tailwind Pagination Component',
  siteIdentifier: 'global',

  pageAriaLabel: 'Page {pageNumber}',
};
